














import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ICompany } from "@/models/company.entity";
import { ITag } from "@/models/tag.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import SelectTags from "./SelectTags.vue";

type IHasPartnerId = Pick<ICompany, "partnerId">;
type IHasTags = Pick<ICompany, "tags">;
type IHasTagIds = Pick<ICompany, "tagIds">;
type HasUpdateTags<T> = { updatePartial: (hasTagIds: IHasTagIds) => Promise<T> };

@Component({
  components: {
    SelectTags
  }
})
export default class SelectUpdateTags<
  T extends IHasPartnerId & IHasTags & IHasTagIds & HasUpdateTags<T>
> extends mixins(PermissionMixin) {
  @Prop({ required: true })
  value!: T;

  @Prop({ required: true })
  resource!: BackendResourceEnum;

  @Prop({ default: false, required: false })
  disabled!: boolean;

  @Prop({ default: false, required: false })
  readonly!: boolean;

  loading = false;

  async onTagsChanged(tags: ITag[]) {
    this.loading = true;
    try {
      const tagIds = tags.map(tag => tag.id);
      this.value.tagIds = tagIds;
      await this.value.updatePartial({ tagIds: this.value.tagIds });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
